export default function (postalCode) {
  return typeof postalCode === "string" && postalCode.length === 4 && /^\d{4}$/.test(postalCode)
}
